import { connect } from 'react-redux';
import { compose } from 'redux'
import { firebaseConnect } from 'react-redux-firebase'
import { createSelector } from 'reselect';
import AddWish from './AddWish';
import { getAddWish } from 'store/addWish/selectors';
import { getIsSmallScreen } from 'store/browser/selectors';
import { setAddWish, clearAddWish } from 'store/addWish/actions';

const mapStateToProps = createSelector(
  getAddWish,
  getIsSmallScreen,
  (addWish, isSmallScreen) => ({
    wish: addWish,
    fullScreen: isSmallScreen
  })
);

const actions = dispatch => ({
  onChange: (field, value) => {
    dispatch(setAddWish({ [field]: value }));
  },
  onSave: () => {
    dispatch(clearAddWish());
  }
});

export default compose(
  firebaseConnect([]),
  connect(mapStateToProps, actions)
)(AddWish);



// WEBPACK FOOTER //
// ./src/components/AddWish/index.js